import type { FunctionComponent } from 'react';

import { TrelloIcon } from '@atlaskit/logo';
import { Tooltip } from '@trello/nachos/tooltip';

import * as styles from './LabsLozenge.module.less';

export const LabsLozenge: FunctionComponent = () => {
  return (
    <span className={styles.lozengeWrapper}>
      <Tooltip content="This feature is still in development.">
        <div className={styles.lozenge}>
          <TrelloIcon size="small" appearance="inverse" />
          <span className={styles.text}>Labs</span>
        </div>
      </Tooltip>
    </span>
  );
};
